module.exports = __webpack_public_path__ + "img/ZG81_04.9195bd61.jpg";